import Employee from "../types/Employee";

const UserInfo = {
  id: "",
  accessToken: "",
  attributes: {} as Employee,
  isAdmin: false
};

export default UserInfo;
